import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import './assets/styles/main.css';
// import 'bootstrap/dist/css/bootstrap.min.css';
// main.js or main.ts
import 'bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
// Import Bootstrap JavaScript
import 'bootstrap/dist/js/bootstrap.bundle.min.js';

import 'toastr/build/toastr.min.css';
import toastr from 'toastr';

import axios from 'axios';
import { apiUrl } from './globalVariable';

// Configure toastr options
toastr.options = {
  closeButton: true,
  debug: false,
  progressBar: true,
  positionClass: 'toast-top-right',
  preventDuplicates: true,
  showDuration: '300',
  hideDuration: '1000',
  timeOut: '5000',
  extendedTimeOut: '1000',
  showEasing: 'swing',
  hideEasing: 'linear',
  showMethod: 'fadeIn',
  hideMethod: 'fadeOut',
};

// Check the token and verify its validity
const token = localStorage.getItem('token');

if (token) {
  axios.post(
    `${apiUrl}verify-token`,
    {},
    {
      headers: { Authorization: `Bearer ${token}` },
    }
  )
    .then((response) => {
      if (!response.data.valid) {
        localStorage.removeItem('token');
        router.push('/');
      }
    })
    .catch((error) => {
      console.error('Error verifying token:', error.response?.data || error);
      localStorage.removeItem('token');
      router.push('/');
    });
}

// Initialize Vue app
const app = createApp(App);

// Attach toastr to global properties
app.config.globalProperties.$toastr = toastr;

// Mount Vue app with router
app.use(router).mount('#app');
